import { Navigate, useRoutes, useParams } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
// guards
import AuthGuard from './components/guards/AuthGuard';
import RoleGuard from './components/guards/RoleGuard';
//
import Landing from "./pages/Landing";
import MutualTrustHistory from './pages/MutualTrustHistory';

import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Page404 from './pages/Page404';
import User from './pages/Users';
import SavingsPr from './pages/President/SavingsPr';
import Savingss from './pages/Savingss';
import Savings from './pages/Savings';
import AddSavings from './pages/AddSavings';
import SavingsList from './pages/SavingsList';
import DashboardAppPage from './pages/DashboardAppPage';
import Admin from './pages/Admin';
import President from './pages/President/President';

import DevPr from './pages/President/DevPr';
import Dev from './pages/Dev/Dev';
import AddDev from './pages/Dev/AddDev';
import DevList from './pages/Dev/DevList';
import DevUser from './pages/Dev/DevUser';

import MinPr from './pages/President/MinPr';
import Min from './pages/Min/Min';                  
import AddMin from './pages/Min/AddMin';
import MinList from './pages/Min/MinList';
import MinUser from './pages/Min/MinUser';

import WelPr from './pages/President/WelPr';
import Wel from './pages/Wel/Wel';                  
import AddWel from './pages/Wel/AddWel';
import WelList from './pages/Wel/WelList';
import WelUser from './pages/Wel/WelUser';

import TakafulPr from './pages/President/TakafulPr';
import Takaful from './pages/Takaful/Takaful';
import AddTakaful from './pages/Takaful/AddTakaful';
import TakafulList from './pages/Takaful/TakafulList';
import TakafulUser from './pages/Takaful/TakafulUser';

import IleyaSavingsPr from './pages/President/IleyaSavingsPr';
import IleyaSavings from './pages/IleyaSavings/IleyaSavings';
import AddIleyaSavings from './pages/IleyaSavings/AddIleyaSavings';
import IleyaSavingsList from './pages/IleyaSavings/IleyaSavingsList';
import IleyaSavingsUser from './pages/IleyaSavings/IleyaSavingsUser';

import SharesPr from './pages/President/SharesPr';
import Shares from './pages/Shares/Shares';
import AddShares from './pages/Shares/AddShares';
import SharesList from './pages/Shares/SharesList';
import SharesUser from './pages/Shares/SharesUser';

import LoanPr from './pages/President/LoanPr';
import Loan from './pages/Loan/Loan';
import AddLoan from './pages/Loan/AddLoan';
import LoanList from './pages/Loan/LoanList';
import LoanUser from './pages/Loan/LoanUser';
import LoanOverview from './pages/Loan/LoanOverview';

import SpeAccPr from './pages/President/SpeAccPr';
import SpeAcc from './pages/SpeAcc/SpeAcc';
import AddSpeAcc from './pages/SpeAcc/AddSpeAcc';
import SpeAccList from './pages/SpeAcc/SpeAccList';
import SpeAccUser from './pages/SpeAcc/SpeAccUser';

import BusinessPr from './pages/President/BusinessPr';
import Business from './pages/Business/Business';
import AddBusiness from './pages/Business/AddBusiness';
import BusinessList from './pages/Business/BusinessList';
import BusinessUser from './pages/Business/BusinessUser';
import BusinessOverview from './pages/Business/BusinessOverview';

import EditUser from './pages/EditUser';
import SummaryPage from './pages/SummaryPage';
import ActivityLogs from './pages/ActivityLogs';
import SettingsPage from './pages/SettingsPage';
import AccountReconciliation from './pages/AccountReconciliation';
import SystemGuide from './pages/SystemGuide';

// import Admin from './pages/Admin/Users';

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
//import PrivateRoute from "./components/private-route/PrivateRoute";

// ----------------------------------------------------------------------

function DirectUserRedirect() {
  const { id } = useParams();
  return <Navigate to={`/dashboard/users/${id}/edit`} replace />;
}

export default function Router() {
  const routes = useRoutes([
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'guide', element: <SystemGuide /> },
	{ path: 'settings', element: <SettingsPage /> },
	{ path: 'president', element: <RoleGuard allowedRoles={['president', 'admin']}><President /></RoleGuard> },
	{ path: 'admin', element: <RoleGuard allowedRoles={['admin', 'financial', 'business']}><Admin /></RoleGuard> },
	{ path: 'financials', element: <RoleGuard allowedRoles={['admin', 'financial', 'president', 'business']}><Admin /></RoleGuard> },
	{ path: 'users', element: <User /> },
	{ path: 'savingspr/:owner', element: <SavingsPr /> },
	{ path: 'savings/:owner', element: <SavingsList /> },
	{ path: 'savings/add/:owner', element: <AddSavings /> },
	{ path: 'savings/:id', element: <Savings /> },
        { path: 'savingss', element: <Savingss /> },
        { path: 'ileyasavingsuser', element: <IleyaSavingsUser /> },
	{ path: 'ileyasavingspr/:owner', element: <IleyaSavingsPr /> },
	{ path: 'ileyasavings/:owner', element: <IleyaSavingsList /> },
	{ path: 'ileyasavings/add/:owner', element: <AddIleyaSavings /> },
        { path: 'ileyasavings/:id', element: <IleyaSavings /> },
	{ path: 'devuser', element: <DevUser /> },
	{ path: 'devpr/:owner', element: <DevPr /> },
	{ path: 'dev/:owner', element: <DevList /> },
	{ path: 'dev/add/:owner', element: <AddDev /> },
        { path: 'dev/:id', element: <Dev /> },

        { path: 'minuser', element: <MinUser /> },
        { path: 'minpr/:owner', element: <MinPr /> },
        { path: 'min/:owner', element: <MinList /> },
        { path: 'min/add/:owner', element: <AddMin /> },                      { path: 'min/:id', element: <Min /> },

	{ path: 'weluser', element: <WelUser /> },
        { path: 'welpr/:owner', element: <WelPr /> },
        { path: 'wel/:owner', element: <WelList /> },
        { path: 'wel/add/:owner', element: <AddWel /> },
	{ path: 'wel/:id', element: <Wel /> },

	{ path: 'takafuluser', element: <TakafulUser /> },
        { path: 'takafulpr/:owner', element: <TakafulPr /> },
        { path: 'takaful/:owner', element: <TakafulList /> },
        { path: 'takaful/add/:owner', element: <AddTakaful /> },
	{ path: 'takaful/:id', element: <Takaful /> },

	{ path: 'sharesuser', element: <SharesUser /> },
	{ path: 'sharespr/:owner', element: <SharesPr /> },
	{ path: 'shares/:owner', element: <SharesList /> },
	{ path: 'shares/add/:owner', element: <AddShares /> },
        { path: 'shares/:id', element: <Shares /> },
	{ path: 'loanuser', element: <LoanUser /> },
	{ path: 'loanpr/:owner', element: <LoanPr /> },
	{ path: 'loan/:owner', element: <LoanList /> },
	{ path: 'loan/add/:owner', element: <AddLoan /> },
        { path: 'loan/:id', element: <Loan /> },
	{ path: 'loan-overview', element: <LoanOverview /> },
	{ path: 'speaccuser', element: <SpeAccUser /> },
	{ path: 'speaccpr/:owner', element: <SpeAccPr /> },
	{ path: 'speacc/:owner', element: <SpeAccList /> },
	{ path: 'speacc/add/:owner', element: <AddSpeAcc /> },
        { path: 'specacc/:id', element: <SpeAcc /> },
	{ path: 'businessuser', element: <BusinessUser /> },
	{ path: 'businesspr/:owner', element: <BusinessPr /> },
	{ path: 'business/:owner', element: <BusinessList /> },
	{ path: 'business/add/:owner', element: <AddBusiness /> },
	{ path: 'business/:id', element: <Business /> },
	{ path: 'business-overview', element: <BusinessOverview /> },
	{ path: 'users/:id/edit', element: <RoleGuard allowedRoles={['admin', 'president', 'registrar', 'secretary', 'financial']}><EditUser /></RoleGuard> },
	{ path: 'summary', element: <SummaryPage /> },
	{ path: 'logs', element: <RoleGuard allowedRoles={['admin', 'president']}><ActivityLogs /></RoleGuard> },
	{ path: 'reconciliation', element: <RoleGuard allowedRoles={['admin', 'financial', 'president']}><AccountReconciliation /></RoleGuard> },
      ],
    },
    {
      path: 'landing',
      element: <Landing />,
    },
    {
      path: 'signup',
      element: <SignupPage />,
    },
    // Safely redirect direct /users/:id to guarded /dashboard/users/:id/edit
    {
      path: 'users/:id',
      element: (
        <AuthGuard>
          <RoleGuard allowedRoles={['admin', 'president', 'registrar', 'secretary', 'financial']}>
            <DirectUserRedirect />
          </RoleGuard>
        </AuthGuard>
      ),
    },
    {
      path: 'settings',
      element: <Navigate to="/dashboard/settings" replace />,
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'forgot-password',
      element: <ForgotPasswordPage />,
    },
    {
      path: 'reset-password',
      element: <ResetPasswordPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/landing" />, index: true },
        { path: 'history', element: <MutualTrustHistory /> },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
